// Home: wordmark and the four mode buttons (disabled until their milestones land).
import { Contours } from '../components/Contours';

type MenuItem = { label: string; hint: string };

const MENU: MenuItem[] = [
  { label: 'Campaign', hint: '24 levels that teach the doctrine' },
  { label: 'TDG', hint: 'Tactical decision games: generated puzzles' },
  { label: 'Free Sim', hint: 'Build your own scenario' },
  { label: 'Field Manual', hint: 'Symbols, graphics and tasks explained' },
];

export function Home() {
  return (
    <main class="home" data-screen="home">
      <Contours />
      <div class="home-inner">
        <header class="brand">
          <h1 class="wordmark">ROC TABLE</h1>
          <p class="tagline">Plan the battle. Press START. Watch it unfold.</p>
        </header>
        <nav class="menu" aria-label="Main menu">
          {MENU.map((m) => (
            <button key={m.label} type="button" class="menu-button" disabled>
              <span class="menu-row">
                <span class="menu-label">{m.label}</span>
                <span class="menu-soon">Coming soon</span>
              </span>
              <span class="menu-hint">{m.hint}</span>
            </button>
          ))}
        </nav>
      </div>
    </main>
  );
}
